import React from 'react';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../../../components/ui/card';
import { Button } from '../../../components/ui/button';
import { Badge } from '../../../components/ui/badge';
import { TabsContent } from '../../../components/ui/tabs';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '../../../components/ui/table';
import { ScrollArea } from '../../../components/ui/scroll-area';
import { Skeleton } from '../../../components/ui/skeleton';
import { TrendingUp, Plus, Edit, Trash2 } from 'lucide-react';

export const BiginDealsTab = ({ deals, deleteDeal, formatCurrency, formatDate, getStageColor, loading, openCreateDeal, openEditDeal }) => (
        <TabsContent value="deals" className="mt-4">
          <Card className="bg-white border shadow-sm">
            <CardHeader>
              <div className="flex items-center justify-between">
                <div>
                  <CardTitle className="text-lg">Pipeline Deals</CardTitle>
                  <CardDescription>{deals.length} deals in pipeline</CardDescription>
                </div>
                <Button onClick={openCreateDeal} className="bg-orange-600 hover:bg-orange-700">
                  <Plus className="w-4 h-4 mr-2" /> Add Deal
                </Button>
              </div>
            </CardHeader>
            <CardContent>
              {loading ? (
                <div className="space-y-3">
                  {[1, 2, 3].map(i => <Skeleton key={i} className="h-16 w-full" />)}
                </div>
              ) : deals.length === 0 ? (
                <div className="text-center py-8 text-gray-500">
                  <TrendingUp className="w-12 h-12 mx-auto mb-3 text-gray-300" />
                  <p>No deals found. Click "Sync Now" to fetch data from Bigin or "Add Deal" to create one.</p>
                </div>
              ) : (
                <ScrollArea className="h-[400px]">
                  <Table>
                    <TableHeader>
                      <TableRow>
                        <TableHead>Deal Name</TableHead>
                        <TableHead>Stage</TableHead>
                        <TableHead>Amount</TableHead>
                        <TableHead>Closing Date</TableHead>
                        <TableHead>Owner</TableHead>
                        <TableHead className="w-24">Actions</TableHead>
                      </TableRow>
                    </TableHeader>
                    <TableBody>
                      {deals.map((deal) => (
                        <TableRow key={deal.bigin_id || deal.id} data-testid="deal-row">
                          <TableCell className="font-medium">
                            {deal.Deal_Name || 'Untitled Deal'}
                          </TableCell>
                          <TableCell>
                            <Badge className={`${getStageColor(deal.Stage)} border`}>
                              {deal.Stage || 'N/A'}
                            </Badge>
                          </TableCell>
                          <TableCell>{formatCurrency(deal.Amount)}</TableCell>
                          <TableCell>{formatDate(deal.Closing_Date)}</TableCell>
                          <TableCell className="text-gray-500">
                            {deal.Owner?.name || 'Unassigned'}
                          </TableCell>
                          <TableCell>
                            <div className="flex items-center gap-1">
                              <Button variant="ghost" size="sm" onClick={() => openEditDeal(deal)} className="h-8 w-8 p-0">
                                <Edit className="w-4 h-4 text-gray-500" />
                              </Button>
                              <Button variant="ghost" size="sm" onClick={() => deleteDeal(deal.id || deal.bigin_id)} className="h-8 w-8 p-0 text-red-500 hover:text-red-700">
                                <Trash2 className="w-4 h-4" />
                              </Button>
                            </div>
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </ScrollArea>
              )}
            </CardContent>
          </Card>
        </TabsContent>
);
